module.exports = __webpack_public_path__ + "static/img/m-device.4833386.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linker/m-device.png
// module id = cLY6
// module chunks = 1